"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const noImage = "images/noImage.png";
exports.default = {
    photoFront: noImage,
    photoBack: noImage,
    photoSide: noImage
};
//# sourceMappingURL=noImage.js.map